import React, { useState } from "react";
import styled from "styled-components";

// Styled Components
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6); /* Semi-transparent black background */
  z-index: 1000;
`;

const ModalContainer = styled.div`
  width: 320px;
  padding: 24px;
  background-color: #3b3b3b; /* Dark gray */
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.2);
`;

const ModalTitle = styled.h2`
  font-family: Verdana, sans-serif;
  font-size: 18px;
  font-weight: bold;
  color: #ffcccb; /* Light red */
  text-align: center;
  margin-bottom: 16px;
`;

const MessageContainer = styled.p`
  font-family: Verdana, sans-serif;
  font-size: 16px;
  color: #ffffff; /* White text */
  line-height: 1.5;
  text-align: center;
  margin-bottom: 24px;
`;

const ActionButton = styled.button`
  padding: 10px 20px;
  background-color: #ff5757; /* Red */
  color: white;
  font-family: Verdana, sans-serif;
  font-weight: bold;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e63939; /* Darker red */
  }
`;

const useErrorDialog = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState<string>("");
  const [onOkAction, setOnOkAction] = useState<() => void>(() => {});

  const showError = (errorMessage: string, okAction?: () => void) => {
    setMessage(errorMessage);
    setOnOkAction(() => okAction || (() => setIsVisible(false)));
    setIsVisible(true);
  };

  const handleOk = () => {
    if (onOkAction) onOkAction();
    setIsVisible(false);
  };

  const ErrorDialog: React.FC = () => {
    if (!isVisible) return null;

    return (
      <Overlay>
        <ModalContainer>
          <ModalTitle>Error</ModalTitle>
          <MessageContainer>{message}</MessageContainer>
          <ActionButton onClick={handleOk}>OK</ActionButton>
        </ModalContainer>
      </Overlay>
    );
  };

  return { showError, ErrorDialog };
};

export default useErrorDialog;
